import _ from '../../common/utility'

function coeHub() {

    if ($('main.coe_hub').length > 0) {
        const pageDomain = getDomain();
        const PortuguesLink = `https://portugues.${pageDomain}medscape.com/temas-especiais/colecao/cardiolatam`;
        const EspanolLink = `https://espanol.${pageDomain}medscape.com/temas-especiales/coleccion/cardiolatam`;
        $('main.coe_hub>header:first-child').append(`
            <div class="header-lang">
                <a href="${EspanolLink}" class="${window.locale === 'es' ? 'active' : ''}"> español </a>
                <a href="${PortuguesLink}" class="${window.locale === 'pt' ? 'active' : ''}"> português </a>
            </div>
        `);
    }

}

export default _.catch(coeHub);